import React, { useState } from 'react';

import { Box, Checkbox, Stack, Text } from '@ekhodealer/ekho-common/rev';

/**
 * Presentational component for Step 4 of the Inventory Data onboarding page.
 * Asks the dealer to confirm they have granted Ekho CMS/DNS access.
 * UI-only — no form submission or API call.
 */
export function EkhoAccessForm(): React.JSX.Element {
	const [isConfirmed, setIsConfirmed] = useState(false);

	return (
		<Box padding='24' background='primary' rounding='12' elevation='0'>
			<Stack itemsSpacing='16'>
				<Text size='title300' weight='bold'>
					Invite Ekho employees with full access
				</Text>
				<Text size='body' color='secondary'>
					To enable Ekho to manage your inventory listings, please grant CMS and DNS access
					to <strong>integrations@ekho.com</strong>. This allows our team to configure your
					website integration and keep your listings in sync.
				</Text>
				<Checkbox
					label="I confirm that I've granted Ekho access to my CMS and DNS"
					isSelected={isConfirmed}
					onChange={setIsConfirmed}
				/>
			</Stack>
		</Box>
	);
}
